module.exports = __webpack_public_path__ + "img/23ea545.png";